import * as React from 'react';

import LinkBadge16 from './LinkBadge16';

export const linkBadge16 = () => <LinkBadge16 />;

export default {
    title: 'Icon|Line|LinkBadge16',
    component: LinkBadge16,
    parameters: {
        notes: "`import LinkBadge16 from 'box-ui-elements/es/icon/line/LinkBadge16';`",
    },
};
